import { styled } from "@mui/system";
import { theme } from "../components/theme";
import { Link } from "gatsby";

const MyLink = styled(Link)({
  textDecoration: "none",
  "&:hover": theme.palette.text.secondary,
  color: theme.palette.text.primary,
});

export default MyLink;